import { DataSource, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMacropointTrackingVendorOptionsPanel extends Layout {
    fourKitesVendorOptions: Panel;
    labelAdvancedOptions: Label;
    labelFourKitesAdvancedOptions: Label;
    labelImagingOptions: Label;
    labelP44AdvancedOptions: Label;
    labelTruckerToolsAdvancedOptions: Label;
    labelVendorOptionsHeader: Label;
    macropointVendorOptionsPanel: Panel;
    panelVendorOptions: Panel;
    project44VendorOptionsPanel: Panel;
    sourceBrTrackingCtrl: DataSource;
    sourceBrTrackingDocTypeMap: DataSource;
    switchAddToOrderHistory: Switch;
    switchAllowForcedCancellation: Switch;
    switchBillCustomerId: Switch;
    switchEnableCoOpSearching: Switch;
    switchEnableGlobalNotifications: Switch;
    switchEnabledInternationalTracking: Switch;
    switchForceCancel: Switch;
    switchFourKitesAllowForcedCancellation: Switch;
    switchIndexToImaging: Switch;
    switchPartnerStatus: Switch;
    switchTruckerToolsForceCancel: Switch;
    switchUpdateCallTimeFourKites: Switch;
    switchUpdateCallTimeMacroPoint: Switch;
    switchUpdateCallTimeP44: Switch;
    switchUpdateCallTimeTruckerTools: Switch;
    switchUseVendorETA: Switch;
    switchUseVendorEta: Switch;
    switchVendorETA: Switch;
    tableDocumentType: Table;
    textboxCallinFrequency: Textbox;
    textboxImagingDropPath: Textbox;
    textboxLastCarrierUpload: Textbox;
    textboxLoadId: Textbox;
    textboxMacropointRequestorId: Textbox;
    textboxNearCityRadius: Textbox;
    textboxNearestCityRadius: Textbox;
    textboxP44TrackingIntervalMins: Textbox;
    textboxRecipents: Textbox;
    textboxScheduleInterval: Textbox;
    textboxShpmtIdentType: Textbox;
    textboxStartTimeOffset: Textbox;
    textboxStartTimePreference: Textbox;
    textboxTTTrackingIntervalMins: Textbox;
    textboxTrackingExt: Textbox;
    textboxTrackingInterval: Textbox;
    textboxTrackingIntervalMins: Textbox;
    textboxTruckerToolsNotificationUsers: Textbox;
    truckerToolsVendorOptionsPanel: Panel;
}
